import { render, staticRenderFns } from "./CasePageSideBarLayout.vue?vue&type=template&id=546adb3c&scoped=true"
import script from "./CasePageSideBarLayout.vue?vue&type=script&lang=js"
export * from "./CasePageSideBarLayout.vue?vue&type=script&lang=js"
import style0 from "./CasePageSideBarLayout.vue?vue&type=style&index=0&id=546adb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546adb3c",
  null
  
)

export default component.exports